console.log("utils.js loaded");
const ajaxPathCompanyModule = '/action/companyModule/';
const ajaxPathLicense = '/action/licenses';
let ajaxLockActive = false;
const ajaxPathBlockedCompany = '/action/blockedCompany';
const ajaxPathTicketIntegration = '/action/fticket-integration';
const ajaxPathTagConfig = '/action/tag'

const ticketIntegrationModalId = 'ticket_integration_modal';
const dealerConfigWrapperSelector = 'div#config-content-wrapper';
const ticketIntegrationDealerConfigSelector = 'div#ticket_integration';
const customerInfoTabId = 'customer_info_tab';

// function triggerPricePopupForDealer(module, syncCode) {
//     var modalId = 'dealer_price_input_modal';
//     var moduleTitle = 'Modulen';
//
//     // remove existing modal
//     if ($('div#' + modalId).length) {
//         $('div#' + modalId).remove();
//     }
//
//     // Save without comment right away, so dealer cant just close dialog and not save
//     saveDealerModulePrice(module, syncCode, "", false);
//
//     // launch popup
//     var modal = '<div class="bootstrap-3-wrapper">' +
//         '<div class="modal fade" id="' + modalId + '" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
//         '  <div class="modal-dialog" role="document">' +
//         '    <div class="modal-content">' +
//         '      <div class="modal-header">' +
//         '        <h4 class="modal-title" id="exampleModalLabel">Pris for ' + moduleTitle + '</h4>' +
//         '      </div>' +
//         '      <div class="modal-body form-horizontal">' +
//         '        <p>' + getModulePrice(module) + ' Kr pr mnd eks MVA ut til kunde</p>' +
//         '        <div class="row">' +
//         '          <div class="col-sm-12">' +
//         '           <textarea type="text" name="comment" placeholder="Kommentar/ønske om prisendring" class="form-control"></textarea>' +
//         '          </div>' +
//         '        </div>' +
//         '      </div>' +
//         '      <div class="modal-footer">' +
//         // '        <button type="button" class="btn btn-default" data-dismiss="modal">Avbryt</button>' +
//         '        <button type="button" class="btn btn-primary" id="save_button" module="' + module + '" sync_code="' + syncCode + '">Ok</button>' +
//         '      </div>' +
//         '    </div>' +
//         '  </div>' +
//         ' </div>' +
//         '</div>';
//
//     $('body').append(modal);
//
//     $('div#' + modalId).modal({
//         backdrop: 'static'
//     });
// }

function triggerPricePopupForDealer(module, syncCode) {
    var modalId = 'dealer_price_input_modal';
    var moduleTitle = 'Modulen';

    // remove existing modal
    if ($('div#' + modalId).length) {
        $('div#' + modalId).remove();
    }

    // Don't save immediately - wait for user to confirm in popup

    // Check if this is API module (module 12) to show purpose field
    var isApiModule = (module == constants.module.api_access);
    var purposeField = '';
    if (isApiModule) {
        purposeField =
            '<div class="mt-5">' +
            '  <label class="block font-semibold mb-2">Formål med API <span class="text-red-500">*</span></label>' +
            '  <input type="text" name="api_purpose" placeholder="Beskriv formålet med API-tilgangen..." class="disabled:bg-slate-100 disabled:cursor-not-allowed transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md placeholder:text-slate-400/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40" required />' +
            '</div>';
    }

    // launch popup
    var modal =
        '<div data-tw-backdrop="static" aria-hidden="true" tabindex="-1" id="' + modalId + '" class="modal group bg-gradient-to-b from-theme-1/50 via-theme-2/50 to-black/50 transition-[visibility,opacity] w-screen h-screen fixed left-0 top-0 [&:not(.show)]:duration-[0s,0.2s] [&:not(.show)]:delay-[0.2s,0s] [&:not(.show)]:invisible [&:not(.show)]:opacity-0 [&.show]:visible [&.show]:opacity-100 [&.show]:duration-[0s,0.4s]">' +
        '  <div class="w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-[margin-top,transform] duration-[0.4s,0.3s] -mt-16 group-[.show]:mt-16 group-[.modal-static]:scale-[1.05] sm:w-[600px]">' +
        '    <div class="flex items-center px-5 py-3 border-b border-slate-200/60">' +
        '      <h2 class="mr-auto text-base font-medium">Pris for ' + moduleTitle + '</h2>' +
        '    </div>' +
        '    <div class="p-5 space-y-4">' +
        '      <p class="text-sm text-slate-700">' + getModulePrice(module) + ' Kr pr mnd eks MVA ut til kunde</p>' +
        purposeField +
        '      <div class="mt-4">' +
        '        <label class="block font-semibold mb-2">Kommentar/ønske om prisendring:</label>' +
        '        <textarea name="comment" placeholder="Kommentar/ønske om prisendring" class="disabled:bg-slate-100 disabled:cursor-not-allowed transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md placeholder:text-slate-400/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40"></textarea>' +
        '      </div>' +
        '    </div>' +
        '    <div class="flex items-center justify-end gap-2 px-5 py-3 text-right border-t border-slate-200/60">' +
        '      <button data-tw-dismiss="modal" type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 disabled:opacity-70 disabled:cursor-not-allowed border-secondary text-slate-500 mr-1 w-20">Avbryt</button>' +
        '      <button type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 disabled:opacity-70 disabled:cursor-not-allowed bg-primary border-primary text-white w-20" id="save_button" module="' + module + '" sync_code="' + syncCode + '">Ok</button>' +
        '    </div>' +
        '  </div>' +
        '</div>';

    $('body').append(modal);

    // Initialize Tailwind modal
    setTimeout(() => {
        const modalElement = document.querySelector('#' + modalId);
        console.log('Modal element found:', modalElement);
        console.log('Tailwind object available:', typeof tailwind !== 'undefined');
        console.log('Tailwind.Modal available:', typeof tailwind !== 'undefined' && typeof tailwind.Modal !== 'undefined');

        if (modalElement) {
            if (typeof tailwind !== 'undefined' && typeof tailwind.Modal !== 'undefined') {
                const modalInstance = tailwind.Modal.getOrCreateInstance(modalElement);
                console.log('Modal instance created:', modalInstance);
                modalInstance.show();

                // Cleanup on close
                modalElement.addEventListener("hidden.tw.modal", (e) => {
                    $(e.currentTarget).remove();
                });
            } else {
                console.error('Tailwind Modal library not available');
                alert('Tailwind Modal library not loaded. Check console for details.');
            }
        } else {
            console.error('Modal element not found in DOM');
        }
    }, 0);
}

function triggerTicketIntegrationPopupForDealer(syncCode) {
    $.ajax({
        type: 'GET',
        url: ajaxPathTicketIntegration + '/organizers',
        data: {},
        dataType: 'json'
    }).success(function (data) {
        launchTicketIntegrationPopup(syncCode, data.options);
    }).error(function (data) {
        alert('Kunne ikke hente tilgjengelige arrangører');
    });
    return false;
}

/**
 *
 * @param syncCode String
 * @param selectOptions String/HTML the options in the select list
 */
function launchTicketIntegrationPopup(syncCode, selectOptions) {
    let moduleTitle = 'Billettintegrasjon, velg konto';

    // remove existing modal
    if ($('div#' + ticketIntegrationModalId).length) {
        $('div#' + ticketIntegrationModalId).remove();
    }

    // launch popup
    var modal =
        '<div data-tw-backdrop="static" aria-hidden="true" tabindex="-1" id="' + ticketIntegrationModalId + '" class="modal group bg-gradient-to-b from-theme-1/50 via-theme-2/50 to-black/50 transition-[visibility,opacity] w-screen h-screen fixed left-0 top-0 [&:not(.show)]:duration-[0s,0.2s] [&:not(.show)]:delay-[0.2s,0s] [&:not(.show)]:invisible [&:not(.show)]:opacity-0 [&.show]:visible [&.show]:opacity-100 [&.show]:duration-[0s,0.4s]">' +
        '  <div class="w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-[margin-top,transform] duration-[0.4s,0.3s] -mt-16 group-[.show]:mt-16 group-[.modal-static]:scale-[1.05] sm:w-[600px]">' +
        '    <div class="flex items-center px-5 py-3 border-b border-slate-200/60">' +
        '      <h2 class="mr-auto text-base font-medium">' + moduleTitle + '</h2>' +
        '    </div>' +
        '    <div class="p-5 space-y-4">' +
        '      <p class="text-sm text-slate-700">Velg arrangør som konto skal knyttes sammen med</p>' +
        '      <div class="mt-2">' +
        '        <select name="ticket_organizer" class="chosen-select disabled:bg-slate-100 disabled:cursor-not-allowed transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40">' +
        '          ' + selectOptions +
        '        </select>' +
        '      </div>' +
        '    </div>' +
        '    <div class="flex items-center justify-end gap-2 px-5 py-3 text-right border-t border-slate-200/60">' +
        '      <button data-tw-dismiss="modal" type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 disabled:opacity-70 disabled:cursor-not-allowed border-secondary text-slate-500 mr-1 w-20">Avbryt</button>' +
        '      <button type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 disabled:opacity-70 disabled:cursor-not-allowed bg-primary border-primary text-white w-20" id="save_button" sync_code="' + syncCode + '">Ok</button>' +
        '    </div>' +
        '  </div>' +
        '</div>';

    $('body').append(modal);

    // Initialize Tailwind modal
    setTimeout(() => {
        const modalElement = document.querySelector('#' + ticketIntegrationModalId);
        console.log('Ticket integration modal element found:', modalElement);
        console.log('Tailwind object available:', typeof tailwind !== 'undefined');

        if (modalElement) {
            if (typeof tailwind !== 'undefined' && typeof tailwind.Modal !== 'undefined') {
                const modalInstance = tailwind.Modal.getOrCreateInstance(modalElement);
                console.log('Ticket modal instance created:', modalInstance);
                modalInstance.show();

                // Cleanup on close
                modalElement.addEventListener("hidden.tw.modal", (e) => {
                    $(e.currentTarget).remove();
                });
            } else {
                console.error('Tailwind Modal library not available for ticket integration');
                alert('Tailwind Modal library not loaded. Check console for details.');
            }
        }

        // Activate searchable select list
        $('div#' + ticketIntegrationModalId + ' select.chosen-select').chosen({width: "50%"});
    }, 0);
}

// Save ticket integration with selected organizer
$(document).on('click', 'div#' + ticketIntegrationModalId + ' button#save_button', function () {
    if (ajaxLockActive) {
        return;
    }

    ajaxLockActive = true;
    let syncCode = $(this).attr('sync_code');
    let organizerId = $('div#' + ticketIntegrationModalId + ' select[name="ticket_organizer"]').val();
    let organizerName = $('div#' + ticketIntegrationModalId + ' select[name="ticket_organizer"]  option:selected').text();

    $.ajax({
        type: 'POST',
        url: ajaxPathTicketIntegration,
        data: {
            organizer_id: organizerId,
            organizer_name: organizerName,
            sync_code: syncCode,
        },
        dataType: 'json'
    }).success(function () {
        const modalElement = document.querySelector('#' + ticketIntegrationModalId);
        if (modalElement) {
            tailwind.Modal.getOrCreateInstance(modalElement).hide();
        }
        updateTicketIntegrationDealerHtml(syncCode)
    }).error(function (data) {
        alert('Kunne ikke lagre integrasjon. ' + data.errors);
        const modalElement = document.querySelector('#' + ticketIntegrationModalId);
        if (modalElement) {
            tailwind.Modal.getOrCreateInstance(modalElement).hide();
        }
    }).always(function (data) {
        ajaxLockActive = false;
    })
});

function updateTicketIntegrationDealerHtml(syncCode) {
    $.ajax({
        type: 'GET',
        url: ajaxPathTicketIntegration + '/dealer-html',
        data: {
            sync_code: syncCode
        },
        dataType: 'json'
    }).success(function (data) {
        $(dealerConfigWrapperSelector + " " + ticketIntegrationDealerConfigSelector).html(data.html);
    }).error(function (data) {
        alert('Kunne ikke oppdatere visning av integrasjon, last siden på nytt. ' + data.errors);
    });
}

// Delete ticket integration   delete_ticket_integration
$(document).on('click', ticketIntegrationDealerConfigSelector + ' button#delete_ticket_integration', function () {
    if (!confirm('Vil du slette integrasjonen med billettsystemet for denne kontoen?')) {
        return;
    }

    let syncCode = $('div#' + customerInfoTabId + ' input#sync_code').val();

    $.ajax({
        type: 'DELETE',
        url: ajaxPathTicketIntegration + '/' + syncCode,
        dataType: 'json'
    }).success(function () {
        updateTicketIntegrationDealerHtml(syncCode);
    }).error(function (data) {
        alert('Kunne ikke slette billettintegrasjon: ' + data.errors);
    });
});

// Save price button clicked
$(document).on('click', '#dealer_price_input_modal button#save_button', function () {
    var module = $(this).attr('module');
    var syncCode = $(this).attr('sync_code');
    var comment = $('#dealer_price_input_modal textarea[name="comment"]').val();
    var apiPurpose = $('#dealer_price_input_modal input[name="api_purpose"]').val();

    // Validate required API purpose field
    if (module == constants.module.api_access && (!apiPurpose || apiPurpose.trim() === '')) {
        alert('Formål med API er påkrevd');
        return;
    }

    console.log('saving price for module');
    saveDealerModulePrice(module, syncCode, comment, true, apiPurpose);
});

// Save price button clicked
$(document).on('click', 'button#ticket_integrated_button', function () {
    var syncCode = $(this).attr('sync_code');

    triggerTicketIntegrationPopupForDealer(syncCode)
});


function saveDealerModulePrice(module, syncCode, comment, closeDialogAfterSave, apiPurpose = '') {
    var data = {
        module: module,
        sync_code: syncCode,
        price_ex_vat_for_customer: getModulePrice(1 * module),
        comment: comment
    };

    // Add API purpose for API module
    if (module == constants.module.api_access && apiPurpose) {
        data.api_purpose = apiPurpose;
    }

    $.ajax({
        type: 'POST',
        url: ajaxPathCompanyModule,
        data: data,
        dataType: 'json'
    }).success(function (data) {
        // Log module activation (action 1) only when user confirms in popup - skip for modules 1 and 2
        var requiresChurnLog = module != constants.module.time_reporting_clocker && module != constants.module.cash_guard;
        if (requiresChurnLog && closeDialogAfterSave) {
            $.post('/action/churn-report/save-license-churn', {
                sync_code: syncCode,
                module_id: module,
                action: 1,
                reason_key: '',
                reason_text: ''
            });
        }

        if (closeDialogAfterSave) {
            const modalElement = document.querySelector('#dealer_price_input_modal');
            if (modalElement) {
                tailwind.Modal.getOrCreateInstance(modalElement).hide();
            }
            // If API module was activated, refresh the API form to show active state
            if (module == constants.module.api_access) {
                try {
                    if (typeof refreshApiForm === 'function') {
                        refreshApiForm();
                    }
                } catch (e) {}
            }
            // If support agreement module was activated, refresh the element to show active state
            if (module == constants.module.support) {
                try {
                    if (typeof window.refreshSupportAgreementElement === 'function') {
                        window.refreshSupportAgreementElement();
                    }
                } catch (e) {
                    console.log('Error refreshing support agreement element:', e);
                }
            }
        }
    }).error(function (data) {
        alert('Kunne ikke lagre pris.');
        if (closeDialogAfterSave) {
            const modalElement = document.querySelector('#dealer_price_input_modal');
            if (modalElement) {
                tailwind.Modal.getOrCreateInstance(modalElement).hide();
            }
        }
    });
    return false;
}

function deleteDealerModulePrice(module, syncCode) {
    var requiresChurnLog = module != constants.module.time_reporting_clocker && module != constants.module.cash_guard;

    if (requiresChurnLog && typeof window.openModuleChurnModal === 'function') {
        window.openModuleChurnModal(module, syncCode, function() {
            executeModuleDeletion(module, syncCode);
        });
    } else {
        executeModuleDeletion(module, syncCode);
    }
    return false;
}

function executeModuleDeletion(module, syncCode) {
    $.ajax({
        type: 'DELETE',
        url: ajaxPathCompanyModule,
        data: {
            module: module,
            sync_code: syncCode
        },
        dataType: 'json'
    }).success(function (data) {
        // Price info deleted
    }).error(function (data) {
        alert('Kunne ikke slette prisinformasjon for modul, vennligst send beskjed til teknisk.');
    });
}

function deactivateModule(companyModuleId) {
    $.ajax({
        type: 'DELETE',
        url: ajaxPathCompanyModule,
        data: {
            company_module_id: companyModuleId
        },
        dataType: 'json'
    }).success(function (data) {
        // Price info deleted
    }).error(function (data) {
        alert('Kunne ikke slette prisinformasjon for modul, vennligst send beskjed til teknisk.');
    });
    return false;
}

function changeLicenseStatus(licenseKey, status, callableFunctionOnSuccess) {
    // Check that a save operation is not already in process
    if (ajaxLockActive) {
        return false;
    }
    ajaxLockActive = true;
    //Post serialized form and save JointAccountsGroup
    $.ajax({
        type: 'PUT',
        url: ajaxPathLicense + '/' + licenseKey,
        data: {
            status: status,
            processed_by_invoicing_department: 0
        },
        dataType: 'json'
    }).success(function () {
        $('div#license_action_wrapper').html(
            '<div class="mt-2 rounded-md border border-emerald-500 bg-emerald-50 px-4 py-2 text-sm text-emerald-800">Lagret</div>'
        );
        if (callableFunctionOnSuccess !== false) {
            callableFunctionOnSuccess();
        }
    }).error(function (data) {
        displayAlertMessage('Kunne ikke endre status!', data.errors, 'danger');
    }).always(function () {
        ajaxLockActive = false;
    });
    return false;
}

function blockCompany(companyId, originButtonId, date) {
    if (isNaN(companyId)) {
        alert("Finner ikke tilknytning til company, kontakt teknisk");
        return;
    }

    var button = $('#' + originButtonId);

    //Post serialized form and save JointAccountsGroup
    $.ajax({
        type: 'POST',
        url: ajaxPathBlockedCompany,
        data: {
            company_id: companyId,
            date: date
        }
    }).success(function () {
        if (date != '') {
            alert('konto blir blokkert ' + date);
            button.html('Fjern fremtidig blokkering (Konto stenges rett før midnatt ' + date + ')');
        } else {
            alert('konto blokkert, hvis kassene er på nett vil blokkering synkes ned til kassene innen 10 minutter');
            button.html('Åpne bruk av konto og kasser');
        }

        button.removeClass('btn-danger');
        button.addClass('btn-success');
        button.attr('id', 'unblock_accounts_and_registers');
    }).error(function (data) {
        alert('Det oppstod en feil, kunne ikke blokkere konto');
    });
}

function unblockCompany(companyId, button) {
    if (isNaN(companyId)) {
        alert("Finner ikke tilknytning til company, kontakt teknisk");
        return;
    }

    //Post serialized form and save JointAccountsGroup
    $.ajax({
        type: 'DELETE',
        url: ajaxPathBlockedCompany,
        data: {
            company_id: companyId
        }
    }).success(function () {
        alert('konto åpnet, Kassene vil synkronisere info ved neste oppstart');
        button.removeClass('btn-success');
        button.addClass('btn-danger');
        button.attr('id', 'block_accounts_and_registers');
        button.html('Blokker bruk av konto og kasser');
    }).error(function (data) {
        alert('Det oppstod en feil, kunne ikke åpne konto');
    });
}

function getModulePrice(module) {
    switch (module) {
        case 1:
            return 0;
        case 2:
            return 200;
        case 3:
            return 150;
        case 4:
            return 150;
        case 5:
            return 990;
        case 6:
            return 0;
        case 7:
            return 500;
        case 8:
            return 0;
        case 9:
            return 500;
        case 10:
            return 590;
        case 11:
            return 195;
        case 12:
            return 590;
        case 13:
            return 590;
        case 14:
            return 450;
        case 15:
            return 299;
        case 16:
            return 0;
        case 17:
            return 0;
        case 18:
            return 450;
        default:
            return 0;
    }
}

/**
 *
 * @param parentElementInDOM element in which modal is appended
 * @param title
 * @param message
 * @param buttonText
 * @param alertType error, success, info
 */
function displayInfoMessageModal(parentElementInDOM, title, message, buttonText, alertType) {
    let modalParent = parentElementInDOM;
    if (!modalParent || !modalParent.length) {
        modalParent = $(parentElementInDOM);
    }
    if (!modalParent || !modalParent.length) {
        modalParent = $('body');
    }

    if ($("div#info_message_modal_wrapper", modalParent).length > 0) {
        $("div#info_message_modal_wrapper", modalParent).remove();
    }

    const hasTailwindModal = typeof tailwind !== 'undefined' && typeof tailwind.Modal !== 'undefined';
    const hasBootstrapModal = typeof $ !== 'undefined' && $.fn && typeof $.fn.modal === 'function';

    let twModalClass = 'border-sky-500';
    let twIcon = '<i class="fa-solid fa-circle-question text-sky-500"></i>';
    let bsTypeClass = 'info';
    let bsIcon = '<i class="fa fa-info-circle"></i>';

    switch (alertType) {
        case 'error':
            twModalClass = 'border-red-500';
            twIcon = '<i class="fa-solid fa-circle-exclamation text-red-500"></i>';
            bsTypeClass = 'danger';
            bsIcon = '<i class="fa fa-exclamation-circle"></i>';
            break;
        case 'success':
            twModalClass = 'border-emerald-500';
            twIcon = '<i class="fa-solid fa-check text-emerald-500"></i>';
            bsTypeClass = 'success';
            bsIcon = '<i class="fa fa-check-circle"></i>';
            break;
    }

    let modalHtml = '';
    if (hasTailwindModal) {
        modalHtml =
            '<div id="info_message_modal_wrapper">' +
            '  <div data-tw-backdrop="" aria-hidden="true" tabindex="-1" id="info_message_modal" class="modal group bg-gradient-to-b from-theme-1/50 via-theme-2/50 to-black/50 transition-[visibility,opacity] w-screen h-screen fixed left-0 top-0 [&:not(.show)]:duration-[0s,0.2s] [&:not(.show)]:delay-[0.2s,0s] [&:not(.show)]:invisible [&:not(.show)]:opacity-0 [&.show]:visible [&.show]:opacity-100 [&.show]:duration-[0s,0.4s]">' +
            '    <div class="w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-[margin-top,transform] duration-[0.4s,0.3s] -mt-16 group-[.show]:mt-16 group-[.modal-static]:scale-[1.05] sm:w-[460px] border-l-4 ' + twModalClass + '">' +
            '      <div class="flex items-center px-5 py-3 border-b border-slate-200/60">' +
            '        <h2 class="mr-auto text-base font-medium flex items-center gap-2">' + twIcon + ' ' + title + '</h2>' +
            '      </div>' +
            '      <div class="p-5 text-sm text-slate-700"><div>' + message + '</div></div>' +
            '      <div class="flex items-center justify-end gap-2 px-5 py-3 text-right border-t border-slate-200/60">' +
            '        <button data-tw-dismiss="modal" type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 disabled:opacity-70 disabled:cursor-not-allowed border-secondary text-slate-500">' + buttonText + '</button>' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>';
    } else {
        modalHtml =
            '<div id="info_message_modal_wrapper" class="bootstrap-3-wrapper">' +
            '  <div class="modal fade" id="info_message_modal" tabindex="-1" role="dialog" aria-hidden="true">' +
            '    <div class="modal-dialog" role="document">' +
            '      <div class="modal-content">' +
            '        <div class="modal-header alert-' + bsTypeClass + '">' +
            '          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '          <h4 class="modal-title">' + bsIcon + ' ' + title + '</h4>' +
            '        </div>' +
            '        <div class="modal-body"><div>' + message + '</div></div>' +
            '        <div class="modal-footer">' +
            '          <button type="button" class="btn btn-default" data-dismiss="modal">' + buttonText + '</button>' +
            '        </div>' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>';
    }

    modalParent.append(modalHtml);

    setTimeout(() => {
        const modalElement = document.querySelector('#info_message_modal');
        if (!modalElement) {
            return;
        }

        if (hasTailwindModal) {
            const modalInstance = tailwind.Modal.getOrCreateInstance(modalElement);
            modalInstance.show();

            $(modalElement).on('click', '[data-tw-dismiss="modal"]', function () {
                modalInstance.hide();
            });
            modalElement.addEventListener('hidden.tw.modal', function () {
                $('#info_message_modal_wrapper').remove();
            }, { once: true });
            return;
        }

        if (hasBootstrapModal) {
            $(modalElement).on('hidden.bs.modal', function () {
                $('#info_message_modal_wrapper').remove();
            });
            $(modalElement).modal({
                backdrop: 'static',
                keyboard: true,
                show: true
            });
            return;
        }

        alert(title + '\n\n' + $('<div>').html(message).text());
        $('#info_message_modal_wrapper').remove();
    }, 0);
}

/**
 * @param {Element} table
 * @param {number} columnToSort
 * @param {string} sortMethod numeric, alphabetic, d/m/Y
 * @param excludeLastTr
 */
function sortTable(table, columnToSort, sortMethod, excludeLastTr = false) {
    var rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        dir,
        switchcount = 0;
    switching = true;
    //Set the sorting direction to ascending:
    dir = "asc";

    let subtractFromRowsLength = 1;
    if (excludeLastTr === true) {
        subtractFromRowsLength = 2;
    }
    /*Make a loop that will continue until
    no switching has been done:*/
    while (switching) {
        //start by saying: no switching is done:
        switching = false;
        rows = table.find('> tbody > tr');
        /*Loop through all table rows (except the
        first, which contains table headers):*/
        for (i = 0; i < rows.length - subtractFromRowsLength; i++) {
            //start by saying there should be no switching:
            shouldSwitch = false;
            /*Get the two elements you want to compare,
            one from current row and one from the next:*/
            x = rows[i].getElementsByTagName("TD")[columnToSort];
            y = rows[i + 1].getElementsByTagName("TD")[columnToSort];
            /*check if the two rows should switch place,
            based on the direction, asc or desc:*/

            /*check if column content is numeric to cast the value to a number
             */
            let xValue = x.innerHTML.toLowerCase();
            let yValue = y.innerHTML.toLowerCase();
            if(sortMethod === 'numeric') {
                xValue = xValue.replace(',', '.') * 1;
                yValue = yValue.replace(',', '.') * 1;
            } else if (sortMethod == 'd/m/Y') {
                // month is 0-based, that's why we need dataParts[1] - 1
                let dateParts = xValue.split("/");
                xValue = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])

                dateParts = yValue.split("/");
                yValue = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
            }

            if (dir == "asc") {
                if (xValue > yValue) {
                    //if so, mark as a switch and break the loop:
                    shouldSwitch = true;
                    break;
                }
            } else if (dir == "desc") {
                if (xValue < yValue) {
                    //if so, mark as a switch and break the loop:
                    shouldSwitch = true;
                    break;
                }
            }
        }
        if (shouldSwitch) {
            /*If a switch has been marked, make the switch
            and mark that a switch has been done:*/
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
            switching = true;
            //Each time a switch is done, increase this count by 1:
            switchcount++;
        } else {
            /*If no switching has been done AND the direction is "asc",
            set the direction to "desc" and run the while loop again.*/
            if (switchcount == 0 && dir == "asc") {
                dir = "desc";
                switching = true;
            }
        }
    }
}

/*
     * Display html message
     *
     * If legend exist in form, the message is appended after legend
     * If legend does not exist in form, the message is appended after fieldset
     *
     * @param String headerText
     * @param String message
     * @param String type
     * @param HTML DOM prependToElement
     */
function displayAlertMessage(headerText, message, type, prependToElement) {
    // Remove any existing alert message
    removeAlertMessage();

    const alertType = type || 'info';
    const bsTypeClass = alertType === 'error' ? 'danger' : alertType;
    const hasBootstrapAlert = typeof $ !== 'undefined' && $.fn && typeof $.fn.alert === 'function';

    const twBaseClass = 'flex w-full items-start justify-between rounded-md border-l-4 px-4 py-3 text-sm shadow-sm';
    const twColorClasses = {
        success: 'bg-success border-success text-white',
        danger: 'bg-danger border-rose-500 text-white',
        warning: 'bg-danger border-amber-500 text-amber-800',
        info: 'bg-sky-50 border-sky-500 text-sky-800'
    };
    const twClass = twBaseClass + ' ' + (twColorClasses[bsTypeClass] || twColorClasses.info);

    // Build html
    let HTMLMessage =
        '<div class="w-full" id="alert_message_container">' +
        '  <div class="alert alert-' + bsTypeClass + ' alert-dismissible ' + twClass + ' mt-3" role="alert" id="alert_message">' +
        '    <div class="flex-1">' +
        '      <h4 class="alert-heading font-semibold">' + headerText + '</h4>' +
        '      <p class="mt-1">' + message + '</p>' +
        '    </div>' +
        '    <button type="button" class="close ml-4 inline-flex items-center justify-center rounded-md bg-transparent text-slate-400 hover:text-slate-600 focus:outline-none" data-dismiss="alert" aria-label="Close">' +
        '      <span aria-hidden="true">&times;</span>' +
        '      <span class="sr-only">Close</span>' +
        '    </button>' +
        '  </div>' +
        '</div>';

    let prependTarget = prependToElement;
    if (!prependTarget || !prependTarget.length) {
        prependTarget = $('div#config-content-wrapper');
    }
    if (!prependTarget || !prependTarget.length) {
        prependTarget = $('body');
    }

    prependTarget.prepend(HTMLMessage);

    if (!hasBootstrapAlert) {
        $('#alert_message').on('click', '[data-dismiss="alert"]', function () {
            removeAlertMessage();
        });
    }
}

function displayAlertMessage2(headerText, message, type, prependToElement) {
    removeAlertMessage();

    var safeHeaderText = $('<div/>').text(headerText || '').html();
    var baseClasses = 'alert show relative border rounded-md px-6 py-4 mb-2 w-[90%] sm:w-[500px] md:w-[600px] lg:w-[700px] mx-auto transition-all duration-300 shadow-sm';
    var typeClasses;

    switch ((type || '').toLowerCase()) {
        case 'success':
            typeClasses = 'bg-success border-success text-white';
            break;
        case 'danger':
        case 'error':
            typeClasses = 'bg-danger border-danger text-white';
            break;
        case 'warning':
            typeClasses = 'bg-warning border-warning text-slate-900';
            break;
        default:
            typeClasses = 'bg-primary border-primary text-white';
            break;
    }

    var htmlMessage = '<div class="w-full" id="alert_message_container">' +
        '<div class="' + baseClasses + ' ' + typeClasses + '" role="alert" id="alert_message">' +
        '<div class="flex items-start justify-between">' +
        '<div>' +
        '<h4 class="font-semibold mb-1">' + safeHeaderText + '</h4>' +
        '<p>' + (message || '') + '</p>' +
        '</div>' +
        '<button type="button" class="text-xl font-bold ml-3 opacity-70 hover:opacity-100 focus:outline-none" data-tw-dismiss="alert" aria-label="Lukk melding">&times;</button>' +
        '</div>' +
        '</div>' +
        '</div>';

    var prependTarget = prependToElement;
    if (!prependTarget || !prependTarget.length) {
        prependTarget = $('div#config-content-wrapper');
    }
    if (!prependTarget || !prependTarget.length) {
        prependTarget = $('body');
    }

    prependTarget.prepend(htmlMessage);

    $('#alert_message').on('click', '[data-tw-dismiss="alert"]', function () {
        removeAlertMessage();
    });
}

/*
 * Remove bootstrap html message from form
 */
function removeAlertMessage() {
    $('div#alert_message').remove();
    $('div#alert_message_container').remove();
}

/*
 * Set Cookie
 */
function SetCookie(cookieName, value, expireDays = 0)
{
    let expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + expireDays);
    document.cookie = cookieName + "=" + escape(value) + ";expires=" + expireDate;
}

/**
 * The delay function will return a wrapped function that internally handles an individual timer,
 * in each execution the timer is restarted with the time delay provided,
 * if multiple executions occur before this time passes, the timer will just reset and start again.
 *
 * When the timer finally ends, the callback function is executed, passing the original context and arguments
 */
function delay(fn, ms) {
    let timer = 0
    return function(...args) {
        clearTimeout(timer)
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
}

function copyToClipboard(valueToCopy, notifyElement, notifyPosition) {
    let temp = $("<input>");
    $("body").append(temp);
    temp.val(valueToCopy).select();

    try {
        let successful = document.execCommand('copy');
        notifyElement.notify(valueToCopy + ' ble kopiert til utklippstavlen', {position: notifyPosition, className: "success"});
        let msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
    } catch (err) {
        console.log('Oops, unable to copy');
    }
    temp.remove();
}

/**
 * Replaces HTML inside elements with a loading gif and adds the optional text to the right of the GIF
 * @param element
 * @param text default value: Henter data...
 */
function displayLoadingGifInElement(element, text = 'Henter data...') {
    element.html(
        '<div class="inline-flex items-center text-sm text-slate-600">' +
        '  <img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." class="mr-2 inline-block h-5 w-5" /> ' +
        text +
        '</div>'
    );
}

/*
 * Notify.js is a jQuery plugin to provide simple yet fully customisable notifications.
 */
$.getScript("/htdocs/js/notify.min.js", function(){ });
/**
 * Adds a spinner to an element. Mainly used when saving a resource
 * @param buttonElement
 * @param buttonText
 */
function addSpinnerToButton(buttonElement, buttonText) {
    buttonElement.html(
        '<span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent align-middle mr-2"></span>' +
        buttonText
    );
    buttonElement.prop("disabled", true);
}

/**
 * Removes a spinner from an element. Mainly used when saving a resource. Used in combination with function "addSpinnerToButton"
 * @param buttonElement
 * @param buttonText
 */
function removeSpinnerFromButton(buttonElement, buttonText) {
    buttonElement.html(buttonText);
    buttonElement.prop("disabled", false);
}

function showButtonSuccessState(buttonElement) {
    const button = buttonElement && buttonElement.jquery ? buttonElement : $(buttonElement);
    if (!button.length) {
        return;
    }

    const getSuccessHtml = function () {
        return '' +
            '<span class="inline-flex items-center justify-center gap-2">' +
            '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.25 7.312a1 1 0 0 1-1.42 0L3.29 9.266A1 1 0 0 1 4.704 7.85l4.046 4.046 6.54-6.6a1 1 0 0 1 1.414-.007Z"></path>' +
            '</svg>' +
            '<span>Lagret</span>' +
            '</span>';
    };
    const getSuccessClasses = function () {
        const originalClass = button.attr('class') || '';
        let successClass = originalClass;

        if (/\btw-btn-[^\s]+\b/.test(successClass)) {
            return successClass.replace(/\btw-btn-[^\s]+\b/g, 'tw-btn-success');
        }

        if (/\bbtn-(primary|danger|warning|default|secondary|info)\b/.test(successClass)) {
            return successClass.replace(/\bbtn-(primary|danger|warning|default|secondary|info)\b/g, 'btn-success');
        }

        successClass = successClass.replace(
            /(^|\s)(bg|border|hover:bg|hover:border)-(primary|danger|warning)(\/[^\s]+)?(?=\s|$)/g,
            '$1$2-success$4'
        );

        if (successClass !== originalClass) {
            return successClass;
        }

        console.warn('showButtonSuccessState: Could not resolve success classes for button.', button[0]);
        return null;
    };
    const successClasses = getSuccessClasses();
    const existingState = button.data('button-success-state') || {};

    if (!successClasses) {
        return;
    }

    if (existingState.timer) {
        window.clearTimeout(existingState.timer);
    }

    const state = {
        originalClass: existingState.originalClass !== undefined ? existingState.originalClass : (button.attr('class') || ''),
        originalHtml: existingState.originalHtml !== undefined ? existingState.originalHtml : button.html(),
        timer: null
    };

    button
        .attr('class', successClasses)
        .html(getSuccessHtml())
        .prop('disabled', false);

    state.timer = window.setTimeout(function () {
        button
            .attr('class', state.originalClass)
            .html(state.originalHtml)
            .prop('disabled', false);
        button.removeData('button-success-state');
    }, 1800);

    button.data('button-success-state', state);
}

/**
 * Instantiate tooltip on page.
 * @param {string} divId
 * @param placement
 */
function activateToolTip(divId, placement = 'right') {
    const $tooltips = $('div#' + divId + ' [data-toggle="tooltip"]');

    if (!$tooltips.length || typeof $.fn.tooltip !== 'function') {
        return;
    }

    $('div#' + divId + ' [data-toggle="tooltip"]').tooltip({
        placement: placement,
        html: true
    });
}

/**
 * Add a parameter to the browser URL without reload. Param is applied to the end of the current URL.
 * @param {string} param
 */
function addParameterToURL(param){
    let browserUrl = location.href;
    browserUrl += (browserUrl.split('?')[1] ? '&':'?') + param;
    window.history.replaceState(null, null, browserUrl);
}

function isValidJson(param) {
    try {
        JSON.parse(param);
        return true;
    } catch (e) {
        return false;
    }
}

function showPreloader() {
    if (!$('#preloader').length) {
        $('body').append(
            '<div id="preloader" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50">' +
            '  <img src="/includes/article/images/loading.gif?v=1.000" class="h-6 w-6" alt="Loading..." />' +
            '</div>'
        );
    }
}

function hidePreloader() {
    $('#preloader').remove();
}

function showTailwindPreloader() {
    if (!$('#tailwind_preloader').length) {
        $('body').append(`<div id='tailwind_preloader' class="fixed bg-theme-1 z-index-top bg-opacity-20 inset-0 flex flex-col items-center justify-center">
                <span class="h-16 w-16">
                    <svg class="h-full w-full" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#2d3748">
                        <g fill="none" fill-rule="evenodd" stroke-width="4">
                            <circle cx="22" cy="22" r="1">
                                <animate values="1; 20" attributeName="r" begin="0s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate>
                                <animate values="1; 0" attributeName="stroke-opacity" begin="0s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate>
                            </circle>
                            <circle cx="22" cy="22" r="1">
                                <animate values="1; 20" attributeName="r" begin="-0.9s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate>
                                <animate values="1; 0" attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" calcMode="spline"
                                    keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate>
                            </circle>
                        </g> 
                    </svg>
                </span>
            </div>`);
    }
}

function hideTailwindPreloader() {
    $('#tailwind_preloader').remove();
}

function displayTailwindAlert(title = '', message = '', parentSelector = 'body', type = 'error', insertType = '', hide = false) {
    const colors = {
        success: 'alert relative border rounded-md px-5 py-4 bg-success border-success text-white',
        error: 'alert relative border rounded-md px-5 py-4 bg-danger border-danger text-white',
        warning: 'alert relative border rounded-md px-5 py-4 bg-warning border-warning text-slate-900 mb-2',
        info: 'alert relative border rounded-md px-5 py-4 bg-primary border-primary text-white',
        gray: 'alert relative border rounded-md px-5 py-4 bg-secondary/70 border-secondary/70 text-slate-500'
    };

    let titleHtml = '';
    if (title) {
        titleHtml = `<div class="text-lg font-medium">${title}</div>`;
    }

    let messageHtml = '';
    if (message) {
        messageHtml = `<div>${message}</div>`;
    }

    const alertHTML = `
        <div role="alert" 
             class="${colors[type] || colors.error} mt-2 ml-2 mr-2 mb-2 hidden">
          <button type="button"
                  class="absolute right-0 top-0 z-10 mr-4 mt-3 text-xl font-bold leading-none opacity-70 transition hover:opacity-100 focus:outline-none"
                  data-tw-dismiss="alert"
                  aria-label="Lukk melding">&times;</button>
          <div class="pr-8">
            ${titleHtml}
            ${messageHtml}
          </div>
        </div>
      `;

    if (insertType === 'replace') {
        $(parentSelector).html(alertHTML);
    } else {
        $(parentSelector).append(alertHTML);
    }
    const $alert = $(parentSelector).find(".alert[role='alert']");


    if ($alert.length) {
        const instance = tailwind.Alert.getOrCreateInstance($alert[0]);

        $alert[0].addEventListener("hidden.tw.alert", (e) => {
            $(e.currentTarget).remove();
        });

        instance.show();

        if (hide) {
            setTimeout(() => instance.hide(), 10000);
        }
    }
}

function parseResponseError(data) {
    let message = 'Det oppsto en feil. Prøv igjen senere.';

    if (data.responseJSON && Array.isArray(data.responseJSON.errors) && data.responseJSON.errors.length > 0) {
        message = data.responseJSON.errors.join('<br>');
    } else {
        try {
            const parsedData = JSON.parse(data.responseText);
            const errors = parsedData.errors;

            if (Array.isArray(errors) && errors.length > 0) {
                message = errors.join('<br>');
            }
        } catch (e) {}
    }

    return message;
}

function dateTimeToTimestamp(dateTime) {
    if (!dateTime) {
        return 0;
    }
    const parts = dateTime.split(/[\s\/:]/);
    const date = new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4]);
    return date.getTime();
}

function showStatusTooltip(element, {
    type = "success",
    title = "",
    message = "",
    durationMs = 2000,
    placement = "right" // <-- default position
} = {}) {

    if (!element) return;

    const typeStyles = {
        success: "border-green-500 text-green-700",
        error: "border-red-500 text-red-700",
        warning: "border-yellow-500 text-yellow-700",
        info: "border-blue-500 text-blue-700"
    };

    const colorClass = typeStyles[type] || typeStyles.success;

    // Build HTML content
    const content = document.createElement("div");
    content.className = "tippy-content";

    content.innerHTML = `
        <div class="flex items-start space-x-3 p-2 border-l-4 ${colorClass}">
            <div class="flex flex-col">
                <div class="font-semibold">${title}</div>
                <div class="text-sm opacity-80">${message}</div>
            </div>
        </div>
    `;

    // Create tippy instance
    const instance = tippy(element, {
        content,
        allowHTML: true,
        interactive: false,
        trigger: "manual",
        placement,             // <--- POSITION CUSTOMIZABLE
        appendTo: document.body,
        theme: type
    });

    instance.show();

    setTimeout(() => {
        instance.hide();
        setTimeout(() => instance.destroy(), 300);
    }, durationMs);
}

function initTailwindValidation() {
    // Define the submit handler (inner helper)
    function onSubmit(pristine) {
        const valid = pristine.validate();

        const toastOptions = {
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "right",
            stopOnFocus: true,
        };

        if (valid) {
            Toastify({
                ...toastOptions,
                node: $("#success-notification-content").clone().removeClass("hidden")[0],
            }).showToast();
        } else {
            Toastify({
                ...toastOptions,
                node: $("#failed-notification-content").clone().removeClass("hidden")[0],
            }).showToast();
        }
    }

    // Loop through all forms that need validation
    $(".validate-form").each(function () {
        const pristine = new Pristine(this, {
            classTo: "input-form",
            errorClass: "has-error",
            errorTextParent: "input-form",
            errorTextClass: "text-danger mt-2",
        });

        // Add custom URL validator
        const urlInput = $(this).find('input[type="url"]')[0];
        if (urlInput) {
            pristine.addValidator(
                urlInput,
                function (value) {
                    const regex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
                    return !value.length || value.match(regex);
                },
                "This field must be a valid URL format"
            );
        }

        // Attach form submit handler
        $(this).on("submit", function (e) {
            e.preventDefault();
            onSubmit(pristine);
        });
    });
}
/**
 * Display error messages in a modal
 *
 * @param title
 * @param data
 * @param parentElementSelector
 */
function showErrors(title, data, parentElementSelector = 'body') {
    let message = 'Det oppsto en feil. Prøv igjen senere.';

    if (data.responseJSON && Array.isArray(data.responseJSON.errors) && data.responseJSON.errors.length > 0) {
        message = data.responseJSON.errors.join('<br>');
    } else {
        try {
            const parsedData = JSON.parse(data.responseText);
            const errors = parsedData.errors;

            if (Array.isArray(errors) && errors.length > 0) {
                message = errors.join('<br>');
            }
        } catch (e) {}
    }

    displayInfoMessageModal($(parentElementSelector, document), title, message, 'Lukk', 'error');
}

/**
 * Reinitializes transition animations for elements with [data-transition].
 * Ensures that dynamically loaded tab sections or components correctly
 * trigger enter/leave animations when their attributes (like class "active") change.
 * Safe to call multiple times — observers are attached only once per element.
 *
 * For example, for Tab
 *
 * @param {Document|string} [context=document]
 */
function reinitTransitions(context = document) {
    const root = typeof context === 'string'
        ? document.querySelector(context)
        : context;

    if (!root) {
        console.error('context element not found');
        return;
    }

    let contextObject;
    if (context === document) {
        contextObject = $(context);
    } else {
        contextObject = $(context, document);
    }

    const lastActive = new WeakMap();

    const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
            if (m.type !== "attributes" || m.attributeName !== "class") continue;

            const el = m.target;
            const isActive = el.classList.contains("active");
            const prev = lastActive.get(el);

            if (prev === undefined) {
                lastActive.set(el, isActive);
                continue;
            }

            if (prev !== isActive) {
                lastActive.set(el, isActive);
                handleTransition(el);
            }
        }
    });

    contextObject.find("[data-transition]").each(function () {
        const el = this;

        if (!el.__transitionObserved) {
            observer.observe(el, {
                attributes: true,
                attributeFilter: ["class"]
            });
            el.__transitionObserved = true;
        }

        lastActive.set(el, el.classList.contains("active"));
        handleTransition(el);
    });

    // Core transition logic (based on the original Tailwind script)
    function handleTransition(t) {
        const $t = $(t);

        // console.log($t)
        const a = $t.clone().html("");
        const hasActive = $($("<div></div>").append(a)).find($(a).data("selector")).length;

        if ($t.data("state") === undefined) {
            $t.data("state", hasActive ? "leave" : "enter");
            hasActive ? $t.show() : $t.hide();
        }

        if (hasActive && $t.data("state") === "leave") {
            $t.data("state", "enter");
            $t.show();
            $t.addClass($t.data("enter-from"));

            setTimeout(() => {
                $t.addClass($t.data("enter"));
                $t.addClass($t.data("enter-to"));
                $t.removeClass($t.data("enter-from"));

                setTimeout(() => {
                    $t.removeClass($t.data("enter"));
                }, parseFloat($t.css("transition-duration")) * 1000);
            });
        } else if (!hasActive && $t.data("state") === "enter") {
            $t.data("state", "leave");
            $t.addClass($t.data("leave-from"));

            setTimeout(() => {
                $t.addClass($t.data("leave"));
                $t.addClass($t.data("leave-to"));
                $t.removeClass($t.data("leave-from"));

                setTimeout(() => {
                    $t.removeClass($t.data("leave"));
                    const current = $t.attr("class") || "";
                    $t.attr(
                        "class",
                        current.split(" ").filter(d => d.search("mt-") === -1).join(" ")
                    );

                    setTimeout(() => {
                        $t.hide();
                    }, 100);
                }, parseFloat($t.css("transition-duration")) * 1000);
            });
        }
    }
}

function getListItemCurrentClasses() {
    return 'bg-primary font-medium text-white hover:bg-primary/90';
}

function getListItemActiveStateClasses() {
    return 'bg-white bg-slate-100 text-slate-800 hover:bg-primary/5';
}

function getListItemInactiveStateClasses() {
    return 'bg-danger text-white hover:opacity-90';
}

function getListItemStateClasses(listItem, index) {
    const listItemElement = $(listItem);

    if (listItemElement.attr('data-status') === '0') {
        return getListItemInactiveStateClasses();
    }

    const rowBackgroundClass = index % 2 === 0
        ? 'bg-white'
        : 'bg-slate-100';

    return rowBackgroundClass + ' text-slate-800 hover:bg-primary/5';
}

function setActiveListItem(listItemSelector, activeItemId, itemIdAttribute) {
    const activeListItemId = parseInt(activeItemId, 10) || 0;

    $(listItemSelector).each(function(index) {
        const listItem = $(this);
        const listItemId = getListItemId(listItem, itemIdAttribute);

        listItem.removeClass(getListItemCurrentClasses());
        listItem.removeClass(getListItemActiveStateClasses());
        listItem.removeClass(getListItemInactiveStateClasses());

        if (listItemId === activeListItemId) {
            listItem.addClass(getListItemCurrentClasses());
        } else {
            listItem.addClass(getListItemStateClasses(listItem, index));
        }
    });
}

function getListItemId(listItem, itemIdAttribute) {
    const listItemElement = $(listItem);
    let listItemId = itemIdAttribute ? listItemElement.attr(itemIdAttribute) : listItemElement.attr('data-id');

    if (listItemId === undefined || listItemId === null || listItemId === '') {
        listItemId = listItemElement.data('id');
    }

    return parseInt(listItemId, 10) || 0;
}


/**
 * Notify.js is a jQuery plugin to provide simple yet fully customisable notifications.
 */
$.getScript("/htdocs/js/notify.min.js", function(){ });
